import { addToRecord, objectWithoutKeys } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { GroupJoinedAction } from '../../domains/groupJoinLeave/actions.types';

import type { JoinGroupRequests } from './types';

export type JoinGroupRequestsAction = GroupJoinedAction;

const initialState: JoinGroupRequests = {};

const reducer: Reducer<JoinGroupRequests, JoinGroupRequestsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP.JOINED_PENDING':
      return addToRecord(state, action.payload.groupId, true);
    case 'GROUP.JOINED_FULFILLED': {
      return objectWithoutKeys(state, [action.payload.groupId]);
    }
    case 'GROUP.JOINED_REJECTED': {
      return objectWithoutKeys(state, [action.payload.groupId]);
    }
    default:
      return state;
  }
};

export default reducer;
